import React from 'react'
import About from '../2'
import { RealEstateDataPageComponentData } from 'types'
//Helpers
const AboutUs15 = (props: RealEstateDataPageComponentData) => {
  return <About {...props} />
}

export default AboutUs15
